import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import { breakpoints } from 'axl-config';
function getSources(sources) {
  const attrs = Object.keys(breakpoints.min).reduce((acc, breakpoint) => {
    // Add srcset definition if supplied
    // NOTE: apparently, order matters, so we are using unshift
    if (sources[breakpoint]) {
      acc.unshift(/*#__PURE__*/_jsx("source", {
        media: `(min-width: ${breakpoints.min[breakpoint]}px)`,
        srcSet: `${sources[breakpoint]}`
      }, breakpoint));
    }
    return acc;
  }, []);
  return attrs;
}

/**
 *  The ArtDirection image allows an responsive image to be rendered with multiple declared sources avaiable for defined breakpoints.
 *  See ArtDirection in https://developer.mozilla.org/en-US/docs/Learn/HTML/Multimedia_and_embedding/Responsive_images for more information
 *
 */
function ArtDirectionImage(_ref) {
  let {
    src,
    className,
    xsSrc,
    smSrc,
    mdSrc,
    lgSrc,
    responsive = true,
    alt = '',
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("picture", {
    "data-cmp": "artDirectionImage"
  }, void 0, getSources({
    xs: xsSrc,
    sm: smSrc,
    md: mdSrc,
    lg: lgSrc
  }), /*#__PURE__*/React.createElement("img", Object.assign({
    className: clsx({
      'img-responsive': responsive
    }, className)
  }, rest, {
    src: src,
    alt: alt,
    key: `img_${new Date().getTime()}`
    // eslint-disable-next-line react/no-unknown-property
    ,
    fetchpriority: "high"
  })));
}
export default ArtDirectionImage;